export default __webpack_public_path__ + "images/0ee9fc57f84ad412cc734f2579a06794.png";